
export default {
  state: {
    list: [],
    current: null,
  },
  actions: {
    getSubjects({commit}, params = {page: 1, per_page: 10}) {
      return axios.get(`/api/v1/student/subject`)
        .then(r => {
          commit("SET_SUBJECTS", r.data.data);
        });
    },
  },
  mutations: {
    SET_SUBJECTS(state, payload) {
      state.list = payload;
    },
  },
  getters:{
    subjects: state => state.list,
  }
};
